import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    dashBoardIcons: {
        fontSize: '24px'
    }
}));

export default useStyles;
